<template>
  <div class="map-container">
    <div class="map-note">
      <div class="note-content">
        <v-icon size="small" color="#666" class="mr-1">mdi-information</v-icon>
        <small class="target-note">Note: Coordinates shown are target deployment locations. Actual buoy positions may vary due to drift.</small>
      </div>
    </div>
    <l-map :zoom="zoom" :center="coordinates" style="height: 100%; width: 100%">
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></l-tile-layer>
      <l-marker :lat-lng="coordinates">
        <l-popup>
          <div class="popup-content">
            <strong>{{ site }}</strong><br />
            <span class="coordinates-label">Target deployment coordinates:</span><br />
            {{ coordinatesString }}
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue3-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "BuoyMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props: {
    site: {
      type: String,
      required: true,
    },
    coordinates: {
      type: Array,
      required: true,
    },
    zoom: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    coordinatesString() {
      return `${this.coordinates[0]}, ${this.coordinates[1]}`;
    },
  },
};
</script>

<style scoped>
.map-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.map-note {
  position: absolute;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 6px 10px;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.note-content {
  display: flex;
  align-items: center;
}

.target-note {
  color: #666;
  font-style: italic;
  font-size: 0.85rem;
}

.popup-content {
  background-color: white;
  color: #1976d2;
  padding: 5px;
}

.coordinates-label {
  font-weight: 500;
}

.leaflet-popup-content-wrapper {
  background-color: white !important;
}

.leaflet-popup-content {
  margin: 0;
}

.leaflet-popup-tip {
  background: white !important;
}
</style>